import { render, staticRenderFns } from "./work-order-detail.vue?vue&type=template&id=657a50ac&"
import script from "./work-order-detail.vue?vue&type=script&lang=js&"
export * from "./work-order-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports